import { render, staticRenderFns } from "./rotate.vue?vue&type=template&id=3f09fbf4&scoped=true&"
import script from "./rotate.vue?vue&type=script&lang=js&"
export * from "./rotate.vue?vue&type=script&lang=js&"
import style0 from "./rotate.vue?vue&type=style&index=0&id=3f09fbf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f09fbf4",
  null
  
)

export default component.exports